import React from 'react';
import ReactDOM from 'react-dom/client';
import '@link/auth/styles/index.css';
import '@linktivity/link-styles';
import '@link/auth/i18n';
import App from '@link/auth/App';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
